<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import MultiselectDropdown from '../../../../../shared/components/ui/MultiselectDropdown.vue';

const props = defineProps({
  services: {
    type: Array,
    default: () => [],
  },
  selectedServiceId: {
    type: [Number, String],
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:selectedServiceId', 'change']);
const { t } = useI18n();

const isSameId = (firstId, secondId) =>
  firstId !== null &&
  firstId !== undefined &&
  secondId !== null &&
  secondId !== undefined &&
  String(firstId) === String(secondId);

const selectedService = computed(() => {
  return (
    props.services.find(service =>
      isSameId(service.id, props.selectedServiceId)
    ) || {}
  );
});

const handleServiceChange = newService => {
  if (props.disabled) return;

  if (isSameId(newService.id, props.selectedServiceId)) {
    emit('update:selectedServiceId', null);
    emit('change', null);
    return;
  }

  emit('update:selectedServiceId', newService.id);
  emit('change', newService);
};
</script>

<template>
  <div>
    <div @click.prevent>
      <MultiselectDropdown
        :options="services"
        :selected-item="selectedService"
        :multiselector-title="t('TICKETS.SERVICE.SELECT_TITLE')"
        :multiselector-placeholder="t('TICKETS.SERVICE.SELECT_PLACEHOLDER')"
        :input-placeholder="t('TICKETS.SERVICE.SEARCH_PLACEHOLDER')"
        :no-search-result="t('TICKETS.SERVICE.NO_RESULTS')"
        :has-thumbnail="false"
        :disabled="disabled"
        @select="handleServiceChange"
      />
    </div>
  </div>
</template>


